module.exports = __webpack_public_path__ + "img/icon_white_reserve.112d5d7c.png";